import { useMutation, useQueryClient } from '@tanstack/react-query';
import useBulkUpdateClient from './useBulkUpdateClient';
import useGetProfile from './useGetProfile';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

interface Payload {
  invites: {
    emailAddress: string;
    clientFirstName: string;
    clientLastName: string;
    clientId: string;
  }[];
}

export default function useBulkInviteClients() {
  const queryClient = useQueryClient();
  const { data: profile } = useGetProfile();
  const { mutate: updateClients } = useBulkUpdateClient();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      updateClients(
        payload.invites.map((inv) => ({
          id: inv.clientId,
          inviteSent: new Date().toISOString(),
          _id: inv.clientId,
        })),
        {
          onSuccess: async () => {
            const response = await fetch(
              `${ENDPOINT}/api/v1/common/email/invite/bulk`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  ...payload,
                  agentName: profile?.firstName,
                  agentBranding: profile.identifier,
                }),
              },
            );

            if (!response.ok) {
              throw new Error(
                `Failed to fetch profile: ${response.statusText}`,
              );
            }

            return (await response.json()).data;
          },
        },
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['CLIENTS'] });
    },
  });
}
